/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Directive, HostListener, Input } from '@angular/core';
import { keyModifier } from 'src/app/plain-javascript/services/key-modifier';

@Directive({
	selector: '[disallowInput]',
})
export class DisallowInputDirective {
	constructor() {}
	/** if the pattern does not match, block the input */
	@Input('disallowInput') public pattern: string;

	@HostListener('keydown', ['$event']) public onkeydown(event: KeyboardEvent) {
		this.inputValidator(event);
	}

	public inputValidator(event: any) {
		const pattern = new RegExp(this.pattern);

		if (keyModifier.isAppleSafeCtrl || event.key.length > 1) {
			return;
		} //special input
		const newValue = event.target.value + event.key;
		if (!pattern.test(newValue)) {
			event.preventDefault();
		}
	}
}
